// @ts-nocheck
export const localeCodes =  [
  "en",
  "de"
]
export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_065d49bc",
      load: () => import("#nuxt-i18n/065d49bc" /* webpackChunkName: "locale_en_46json_065d49bc" */),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_599fdf2a",
      load: () => import("#nuxt-i18n/599fdf2a" /* webpackChunkName: "locale_de_46json_599fdf2a" */),
      cache: true
    }
  ]
}
export const vueI18nConfigs = []
export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    language: undefined
  },
  {
    code: "de",
    name: "German",
    language: undefined
  }
]
/** client **/

/** client-end **/